// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import BootstrapVue from 'bootstrap-vue';
import { set } from 'core-js/core/dict';
import 'core-js/es6/promise'
// import cssVars from 'css-vars-ponyfill'
import 'core-js/es6/string'
import 'core-js/es7/array'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import SweetModal from 'sweet-modal-vue/src/plugin.js'
import Vue from 'vue';
import VueApexCharts from 'vue-apexcharts'
import AsyncComputed from 'vue-async-computed'
import VueLazyload from 'vue-lazyload'
import VueLoaders from 'vue-loaders';
import 'vue-loaders/dist/vue-loaders.css';
import Notifications from 'vue-notification';
import Toasted from 'vue-toasted';
import VueTour from 'vue-tour'
import VueWorker from 'vue-worker';
/* Initialize the plugin */
Vue.use(AsyncComputed)
Vue.use(require('vue-moment'));
Vue.use(VueYoutube);
Vue.use(require('vue-moment'));
Vue.use(VueWorker);
Vue.use(ElementUI);
Vue.use(require('vue-moment'));
Vue.use(Notifications)
import VueYoutube from 'vue-youtube';
Vue.use(ProgressBar)
import ProgressBar from 'vuejs-progress-bar'
import Vuex from 'vuex';
require('vue-tour/dist/vue-tour.css');
Vue.use(VueTour)
Vue.use(Vuex);
import * as Sentry from '@sentry/browser';

 
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: 'https://imagemagikassets.s3.eu-central-1.amazonaws.com/assets/comp_3.gif',
  loading: 'https://imagemagikassets.s3.eu-central-1.amazonaws.com/assets/ringloader.gif',
  attempt: 5,
  // the default is ['scroll', 'wheel', 'mousewheel', 'resize', 'animationend', 'transitionend']
  listenEvents: [ 'scroll' ]
})
import {BASE_URL} from '../env';
Vue.component('apexchart', VueApexCharts);
import App from './App';
import router from './router';

Sentry.init({ dsn: 'https://07046bc65c3946cdae8a2e5950dccaa6@o1143898.ingest.sentry.io/6205011' });

function saveItem(key, val) {

  localStorage[key] = val

}

function deleteItem(key) {

  localStorage.removeItem(key)

}

function getItem(key) {

  const existing = localStorage.getItem(key) || null;

  return existing
}

const store = new Vuex.Store({
  state: {
      currentToken: null,
      currentUsername: null,
      currentUserId: null,
      currentImageSrc: null,
      currentEditorSid: null,
      userType: null,
      selectedPackageId: null,
      trialUses: 0,
      inpaintTourCompleted: false,
      currentSid: null,
      currentFeatures: null

  },
  mutations: {
      increment (state) {
          state.notifcount++
      },
      clearToken (state) {
        state.currentToken = null;
      },
      setCurrentSid (state, sid) {
        console.log(sid)
        state.currentSid = sid;
      },
      setcurrentToken (state, token) {
          state.currentToken = token;
      },
      setcurrentImageScr (state, src) {
        state.currentImageSrc = src;
      },
      setLocalcurrentToken (state, token) {
        saveItem('tok', state.currentToken)
      },
      setcurrentUsername (state, username) {
        state.currentUsername = username;

        // saveItem('usn', state.currentUsername)
      },
      setcurrentUserId (state, userid) {
        state.currentUserId = userid;

        // saveItem('uid', state.currentUserId)
      },
      setCurrentFeatures (state, features) {
        state.currentFeatures = features;
        const json = JSON.stringify(features);
        saveItem('features', json);
      },
      setUserType (state, usertype) {
        state.userType = usertype;
      },
      setTrialUses (state, uses) {
        state.trialUses = uses;
      }
  },
  actions: {
      "customEmit" () {
          // do something
          console.log('customedit')
      },
      clearData (context) {
        // state.currentToken = null;
        context.commit('clearToken');

        deleteItem('tok');

        deleteItem('tour_inpaint');

      },
      
      clearLocalToken (context) {

        deleteItem('tok');
      } 
  },
  getters: {
    // Check if user is logged in
    isUserLoggedIn: state => {

      if (getItem('tok')) {
        return getItem('tok').length > 4;
      }

      return state.currentToken?state.currentToken.length > 4: false;
    },

    getCurrentToken: state => {

      if (state.currentToken) {

        return state.currentToken
      }

      if (getItem('tok')) {
        
        const token = getItem('tok');
        
        state.currentToken = token;

        return token;
      }
    },
    getCurrentUsername: state => {

      if (getItem('usn')) {
        return getItem('usn');
      }

      return state.currentUsername;
    },
    getCurrentSid: state => {

      return state.currentSid;
    },
    getInpaintTourComplete: state => {

      return state.inpaintTourCompleted;
    },
    getCurrentUserId: state => {

      if(state.currentUserId) {
        return state.currentUserId;
      }

      if (getItem('uid')) {
        return getItem('uid');
      }
    },
    getCurrentImageSrc: state => {

      return state.currentImageSrc;
    },
    getisTrial: state => {
      return state.isTrial;
    },
    gettrialUses: state => {
      return state.trialUses;
    },
    getisTrialMaxedOut: state => {
      return state.trialUses >= 15 && state.isTrial;
    },
    getCurrentFeatures: state => {
      if(getItem('features')) {
        return JSON.parse(getItem('features')) ;
      }
      return state.currentFeatures;
    },
  },
})


// todo
// cssVars()
Vue.prototype.$baseurl = BASE_URL;



Vue.use(BootstrapVue);
Vue.use(VueLoaders);
Vue.use(Toasted);
Vue.use(SweetModal);

router.beforeEach((to, from, next) => {
  return next();
});

Vue.prototype.$eventHub = new Vue();

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})
